module.exports = __webpack_public_path__ + "static/media/task-active.ff179919.svg";